<template>
  <div style="height: 100%;" class="d-flex flex-column justify-center align-center">
    <img src="/img/domains-empty.svg" style="max-width: 90px;">
    <strong class="mt-3">Cadastre o seu primeiro domínio.</strong>
    <v-btn class="mt-6" color="grey" text @click="$router.push('/aprender-e-praticar?v=gBnB2-rnuGU')">
      Saiba como fazer
    </v-btn>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>

</style>